<template>
  <span class="loading-dots">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </span>
</template>

<style scoped lang="scss">
.loading-dots {
  display: flex;
  justify-content: center;
}

.dot {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  background-color: gainsboro;
  border-radius: var(--t-border-radius-half-rounded);
  animation: loadingAnimation 1s infinite ease-in-out;
}

.dot:nth-child(2) {
  animation-delay: 0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.2s;
}

@keyframes loadingAnimation {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
</style>
